import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-angle_up",
  "use": "rt-base-angle_up-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"rt-base-angle_up\"><defs><style type=\"text/css\"></style></defs><path d=\"M772.4 667.4L528.8 336.6c-8.4-11.5-25.1-11.5-33.5 0L251.6 667.4c-8.7 11.7-0.6 28.6 13.5 28.6H759c14 0 22-16.9 13.4-28.6z\" p-id=\"2370\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/angle_up.svg
// module id = 1244
// module chunks = 91